import { render, staticRenderFns } from "./WikiEditorOnlineUsers.vue?vue&type=template&id=3f18b58e&"
import script from "./WikiEditorOnlineUsers.vue?vue&type=script&lang=js&"
export * from "./WikiEditorOnlineUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports